import { Form, FormProps, message } from "antd";
import api from "common/api";
import { IEmployee } from "common/types/employee";
import { INews } from "common/types/news";
import { FieldData } from "rc-field-form/es/interface";
import React, { FC, createContext, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const Context = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const onFinish: FormProps["onFinish"] = async (values) => {
    try {
      const payload = {
        ...values,
      };
      const response = await api.employee.addEmployee(payload, id);
      message.success("Xodim yaratildi");
      navigate(-1);
    } catch (err) {
      console.log(err);
    }
  };

  const getById = async (id: string) => {
    try {
      const response = await api.employee.getById(id);
      const fields: FieldData[] = (
        Object.keys(response.data) as (keyof IEmployee)[]
      ).map((key) => ({
        name: key,
        value: response.data[key],
      }));
      form.setFields(fields);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDelete = async () => {
    if (id)
      try {
        const response = await api.employee.delete(id);
        message.success("Xodim o'chirildi");
        navigate(-1);
      } catch (err) {
        console.log(err);
      }
    else navigate(-1);
  };

  useEffect(() => {
    if (id) getById(id);
  }, []);

  return {
    state: { form },
    actions: { onFinish, handleDelete },
  };
};

const EmployeesAddContext = createContext<any>({ state: {}, actions: {} });

export const EmployeesAddContextProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const value = Context();
  return (
    <EmployeesAddContext.Provider value={value}>
      {children}
    </EmployeesAddContext.Provider>
  );
};

export default function useEmployeesAddContext() {
  return useContext<ReturnType<typeof Context>>(EmployeesAddContext);
}
